(function () {
  'use strict';

  angular
    .module('users.list')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('settings.users.list', {
        url: '',
        templateUrl: 'settings/users/list/list.tpl.html',
        controller: 'UsersListCtrl',
        controllerAs: 'vm'
      })
    ;
  }
}());
